import { Buffer } from 'buffer';
import branca from 'branca';
import * as msgpack from '@msgpack/msgpack';

if (typeof window !== 'undefined') {
  (window as any).Buffer = Buffer;
}

const secretKey = '7ed049e344f73f399ba1f7868cf9494f4b13347ecce02a8e463feb32507b73a5';
const brancaInstance = branca(secretKey);

export const encode = (payload: any, createdAt?: string): string => {
  const dayjs = useDayjs();
  const timestamp: any = createdAt || dayjs().format('X');
  const packed = msgpack.encode(payload, timestamp);
  return brancaInstance.encode(packed);
};
